export const nav = {
    permissao: 'hdocs.documentos:ver',
    section: 'Documentos',
    title: 'Documentos',
    icon: 'inventory_2',
    route: '/documentos',
    sequence: 2,
};

export default [
    {
        path: '/documentos',
        name: 'documentos',
        component: () => import('./pages/DocumentosPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.documentos:ver' },
    },
];
